import React from 'react';
import { Box, BoxProps, Heading } from '@hover/blueprint';

interface Props extends BoxProps {
  body: string;
  image: React.ReactNode;
}

const CustomerCard: React.FC<Props> = ({ image, body, ...restProps }) => (
  <Box
    p={700}
    borderRadius="6px"
    boxShadow="distance300"
    flexDir="column"
    alignItems="flex-start"
    {...restProps}
  >
    <Box
      h={{ base: 'auto', desktop: '68px' }}
      alignItems="flex-start"
      flexDir="row"
      justifyContent="flex-start"
      mb={700}
    >
      {image}
    </Box>
    <Heading as="p" marginBottom={0} isDisplay size={400}>
      {body}
    </Heading>
  </Box>
);

export default CustomerCard;
